"use client";

import { siteContent } from "@/lib/data";

export default function NewsletterForm() {
  const { newsletter } = siteContent;
  return (
    <form
      className="mt-4 flex items-center rounded-[var(--radius-pill)] bg-[color:var(--color-surface)] border border-[color:var(--color-border)] p-1"
      onSubmit={(e) => e.preventDefault()}
    >
      <label htmlFor="footer-email" className="sr-only">
        {newsletter.inputLabel}
      </label>
      <input
        id="footer-email"
        type="email"
        placeholder={newsletter.inputLabel}
        className="flex-1 min-w-0 bg-transparent px-4 py-2 text-sm outline-none placeholder:text-[color:var(--color-muted)]"
      />
      <button
        type="submit"
        className="shrink-0 rounded-[var(--radius-pill)] bg-[color:var(--color-primary)] px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white hover:bg-[color:var(--color-primary-dark)]"
      >
        {newsletter.submitLabel}
      </button>
    </form>
  );
}
